<template>
    <div class="main">
        <c-panel title="AVALIAÇÃO DIFERENCIADA" titleIcon="fas fa-universal-access">

            <el-alert type="info" :closable="false" class="u-mb-15"
                title="A avaliação diferenciada acompanha o aluno e vale até ser revogada. O histórico é preservado: editar significa revogar a regra vigente e criar outra."></el-alert>

            <el-row class="u-mt-10 u-mb-20" :gutter="10">
                <el-col :xs="24" :sm="14">
                    <el-select v-model="alunoId" filterable remote reserve-keyword clearable style="width: 100%;"
                        placeholder="Digite o nome do aluno..." :remote-method="buscarAluno" :loading="buscando" @change="load">
                        <el-option v-for="a in alunos" :key="a.id" :value="a.id" :label="a.nome"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="10" class="u-text-right">
                    <el-button v-if="podeEscrever" type="primary" :disabled="!alunoId" @click="abrirNovo">NOVA AVALIAÇÃO DIFERENCIADA</el-button>
                </el-col>
            </el-row>

            <div class="container-table" v-if="alunoId">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th class="hidden-mobile" style="width: 60px;">cod</th>
                            <th style="width: 190px;">Tipo de avaliação</th>
                            <th>Turma</th>
                            <th class="hidden-mobile">Disciplina</th>
                            <th class="u-text-center" style="width: 100px;">Início</th>
                            <th class="u-text-center" style="width: 100px;">Fim</th>
                            <th class="u-text-center" style="width: 110px;">Vigência</th>
                            <th class="hidden-mobile" style="width: 150px;">Autoria</th>
                            <th style="width: 130px;" class="u-text-center" v-if="podeEscrever">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="item in items" :key="item.id">
                            <td class="hidden-mobile">{{ item.id }}</td>
                            <td>{{ item.tipo_avaliacao ? item.tipo_avaliacao.nome : '—' }}</td>
                            <td>{{ item.turma ? item.turma.nome : 'Qualquer turma' }}</td>
                            <td class="hidden-mobile">{{ item.area_conhecimento ? item.area_conhecimento.nome_area : 'Qualquer disciplina' }}</td>
                            <td class="u-text-center">{{ item.data_inicio | data }}</td>
                            <td class="u-text-center">{{ item.data_fim ? $options.filters.data(item.data_fim) : '—' }}</td>
                            <td class="u-text-center">
                                <el-tag :type="vigente(item) ? 'success' : 'info'" size="mini">{{ vigente(item) ? 'VIGENTE' : 'ENCERRADA' }}</el-tag>
                            </td>
                            <td class="hidden-mobile" style="font-size: 11px;">
                                <div v-if="item.criado_por">criada por {{ item.criado_por.name }}</div>
                                <div v-if="item.revogado_por">revogada por {{ item.revogado_por.name }}</div>
                                <div v-if="item.motivo_revogacao" style="color: #909399;">{{ item.motivo_revogacao | truncate(40, '...') }}</div>
                            </td>
                            <td class="u-text-center acao" v-if="podeEscrever">
                                <template v-if="vigente(item)">
                                    <el-button @click="abrirEdicao(item)" title="Editar" type="info" icon="el-icon-edit" size="mini" plain class="u-mr-10"></el-button>
                                    <el-button @click="revogar(item)" title="Revogar" type="warning" icon="el-icon-close" size="mini" plain></el-button>
                                </template>
                                <span v-else style="color: #909399; font-size: 11px;">histórico</span>
                            </td>
                        </tr>
                        <tr v-if="!items.length">
                            <td :colspan="podeEscrever ? 9 : 8" class="u-text-center" style="padding: 20px; color: #909399;">Este aluno não possui avaliação diferenciada.</td>
                        </tr>
                    </tbody>
                </table>

                <div v-if="!statusList" class="u-text-center u-mt-25">
                    <img src="/public/img/loading-bar.gif" />
                </div>
            </div>

            <el-alert v-else type="info" :closable="false" title="Selecione um aluno para consultar as avaliações diferenciadas."></el-alert>
        </c-panel>

        <!-- Criação / edição append-only -->
        <el-dialog :title="edicao ? 'Editar avaliação diferenciada' : 'Nova avaliação diferenciada'" :visible.sync="dialogForm" width="720px">
            <el-alert v-if="edicao" type="warning" :closable="false"
                title="Editar revoga a configuração vigente e cria uma nova a partir da data informada. O registro anterior é preservado no histórico."></el-alert>

            <el-form label-position="top" :model="form" ref="form" class="u-mt-20">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Tipo de avaliação" prop="tipo_avaliacao_id" :rules="[$requiredChange]">
                            <el-select v-model="form.tipo_avaliacao_id" style="width: 100%;" filterable>
                                <el-option v-for="t in tipos" :key="t.id" :value="t.id" :label="t.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Turma">
                            <el-select v-model="form.turma_id" style="width: 100%;" filterable clearable placeholder="Qualquer turma (somente perfis da rede)">
                                <el-option v-for="t in turmas" :key="t.id" :value="t.id" :label="rotuloTurma(t)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Disciplina">
                            <el-select v-model="form.area_conhecimento_id" style="width: 100%;" filterable clearable placeholder="Qualquer disciplina">
                                <el-option v-for="d in disciplinas" :key="d.id" :value="d.id" :label="d.nome_area"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="6">
                        <el-form-item label="Início da vigência" prop="data_inicio" :rules="[$requiredChange]">
                            <el-date-picker v-model="form.data_inicio" type="date" style="width: 100%;" format="dd/MM/yyyy" value-format="yyyy-MM-dd"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="6" v-if="!edicao">
                        <el-form-item label="Fim (opcional)">
                            <el-date-picker v-model="form.data_fim" type="date" style="width: 100%;" format="dd/MM/yyyy" value-format="yyyy-MM-dd"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Justificativa">
                            <el-input type="textarea" :rows="2" v-model="form.justificativa"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10" v-if="edicao">
                    <el-col :xs="24">
                        <el-form-item label="Motivo da substituição">
                            <el-input v-model="form.motivo_revogacao"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <span slot="footer">
                <el-button @click="dialogForm = false">CANCELAR</el-button>
                <el-button class="u-ml-10" type="primary" @click="salvar">SALVAR</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    filters: {
        data (v) { return v ? String(v).substring(0, 10).split('-').reverse().join('/') : '' }
    },
    data: () => ({
        statusList: false,
        alunoId: '', alunos: [], buscando: false,
        items: [],
        tipos: [], turmas: [], disciplinas: [],
        dialogForm: false, edicao: null,
        form: { tipo_avaliacao_id: '', turma_id: '', area_conhecimento_id: '', data_inicio: '', data_fim: '', justificativa: '', motivo_revogacao: '' }
    }),
    computed: {
        // Escrita reservada aos perfis de rede (matriz aprovada na B8).
        podeEscrever () { return [4, 5, 6, 7].includes(Number(this.$store.state.user.tipo)) }
    },
    methods: {
        vigente (item) {
            if (item.revogado_em) return false
            if (!item.data_fim) return true
            return String(item.data_fim).substring(0, 10) >= new Date().toISOString().substring(0, 10)
        },
        buscarAluno (query) {
            if (!query || query.length < 3) return
            this.buscando = true
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/aluno/getAllPaginate/${this.$store.state.config.periodo.id}?page=1`,
                { nome: query },
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.alunos = (r.data && r.data.data) ? r.data.data : []
                this.buscando = false
            }).catch(() => { this.buscando = false })
        },
        load () {
            if (!this.alunoId) { this.items = []; return }
            this.statusList = false
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/desempenho-diferenciado/getPorAluno/${this.alunoId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) {
                    this.items = []
                    this.statusList = true
                    window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                    return
                }
                this.items = Array.isArray(r.data) ? r.data : []
                this.statusList = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        /**
         * As turmas vêm do ALUNO, não da escola em contexto.
         *
         * Antes a lista saía de `turma/getAllTurmas/{escola}/{periodo}` e só era buscada
         * quando havia escola no contexto. Perfil de rede não tem escola em contexto, então
         * a requisição nunca saía e o select mostrava "Sem dados" — justo para quem o
         * backend permite deixar a turma em branco, e que por isso mais precisa da lista.
         * Havia ainda o caso do aluno matriculado em escola diferente da do contexto, cuja
         * turma jamais apareceria.
         */
        carregarApoio () {
            if (!this.tipos.length) {
                this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/tipo-avaliacao/getAll`, this.$store.getters.getHeaderAuth)
                    .then(r => { this.tipos = r.data || [] }).catch(() => {})
                this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/area-conhecimento/getAll`, this.$store.getters.getHeaderAuth)
                    .then(r => { this.disciplinas = r.data || [] }).catch(() => {})
            }
            this.carregarTurmasDoAluno()
        },
        carregarTurmasDoAluno () {
            this.turmas = []
            if (!this.alunoId) return
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/desempenho-diferenciado/turmasDoAluno/${this.alunoId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.turmas = Array.isArray(r.data) ? r.data : [] }).catch(() => {})
        },
        /** A turma pode ser de outra escola ou de ano anterior — o rótulo precisa dizer qual. */
        rotuloTurma (t) {
            const partes = [t.nome]
            if (t.instituicao_nome) partes.push(t.instituicao_nome)
            if (t.periodo_nome) partes.push(t.periodo_nome)
            return partes.join(' — ')
        },
        abrirNovo () {
            this.carregarApoio()
            this.edicao = null
            this.form = { tipo_avaliacao_id: '', turma_id: '', area_conhecimento_id: '', data_inicio: '', data_fim: '', justificativa: '', motivo_revogacao: '' }
            this.dialogForm = true
        },
        abrirEdicao (item) {
            this.carregarApoio()
            this.edicao = item
            this.form = {
                tipo_avaliacao_id: item.tipo_avaliacao_id,
                turma_id: item.turma_id || '',
                area_conhecimento_id: item.area_conhecimento_id || '',
                data_inicio: '', data_fim: '',
                justificativa: item.justificativa || '',
                motivo_revogacao: ''
            }
            this.dialogForm = true
        },
        salvar () {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' })
                    return
                }
                window.eventBus.$emit('loading', true)
                // Editar chama o endpoint de edição: quem revoga a anterior e cria a
                // nova é a API, dentro de uma transação.
                const url = this.edicao
                    ? `${this.$store.state.config.baseUrlApi}/api/desempenho-diferenciado/editar/${this.edicao.id}`
                    : `${this.$store.state.config.baseUrlApi}/api/desempenho-diferenciado/store`
                const payload = Object.assign({ aluno_id: this.alunoId }, this.form)
                this.$axios.post(url, payload, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Salvo com sucesso.', type: 'success' })
                    this.dialogForm = false
                    this.load()
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        },
        revogar (item) {
            this.$msgbox.prompt('Informe o motivo da revogação:', 'Revogar avaliação diferenciada', {
                confirmButtonText: 'Revogar', cancelButtonText: 'Cancelar',
                inputValidator: v => (v && v.trim() !== '') ? true : 'O motivo é obrigatório.'
            }).then(({ value }) => {
                window.eventBus.$emit('loading', true)
                this.$axios.post(
                    `${this.$store.state.config.baseUrlApi}/api/desempenho-diferenciado/revogar/${item.id}`,
                    { motivo: value },
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Revogada com sucesso.', type: 'success' })
                    this.load()
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            }).catch(() => {})
        }
    }
}
</script>
